import { render, staticRenderFns } from "./BooleanRadios.vue?vue&type=template&id=535e683a&scoped=true&"
import script from "./BooleanRadios.vue?vue&type=script&lang=ts&"
export * from "./BooleanRadios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e683a",
  null
  
)

export default component.exports